export class PrimevueLocale {
    constructor() {
        this.locale = {
            startsWith: 'Starter med',
            contains: 'Indeholder',
            notContains: 'Indeholder ikke',
            endsWith: 'Slutter med',
            equals: 'Lig med',
            notEquals: 'Ikke lig med',
            noFilter: 'Intet filter',
            lt: 'Mindre end',
            lte: 'Mindre end eller lig med',
            gt: 'Større end',
            gte: 'Større end eller lig med',
            dateIs: 'Dato er',
            dateIsNot: 'Dato er ikke',
            dateBefore: 'Dato re før',
            dateAfter: 'Dato er efter',
            clear: 'Ryd',
            apply: 'Anvend',
            matchAll: 'Match Alle',
            matchAny: 'Match Nogle',
            addRule: 'Tilføj Regel',
            removeRule: 'Fjern Regel',
            accept: 'Ja',
            reject: 'Nej',
            choose: 'Vælg',
            upload: 'Upload',
            cancel: 'Annuller',
            completed: 'Gennemført',
            pending: 'Afventer',
            dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
            dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
            dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
            monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
            chooseYear: 'Vælg År',
            chooseMonth: 'Vælg Måned',
            chooseDate: 'Vælg Dato',
            prevDecade: 'Forrige Årti',
            nextDecade: 'Næste Årti',
            prevYear: 'Forrige År',
            nextYear: 'Næste År',
            prevMonth: 'Forrige Måned',
            nextMonth: 'Næste Måned',
            prevHour: 'Forrige Time',
            nextHour: 'Næste Time',
            prevMinute: 'Forrige Minut',
            nextMinute: 'Næste Minut',
            prevSecond: 'Forrige Sekundt',
            nextSecond: 'Næste Sekundt',
            am: 'am',
            pm: 'pm',
            today: 'I dag',
            weekHeader: 'Ug',
            firstDayOfWeek: 1,
            dateFormat: 'dd/mm/yy',
            weak: 'Svag',
            medium: 'Medium',
            strong: 'Stærk',
            passwordPrompt: 'Indtast en adgangskode',
            emptyFilterMessage: 'Intet resultat', // @deprecated Use 'emptySearchMessage' option instead.
            searchMessage: '{0} resultater er fundet',
            selectionMessage: '{0} er valgt',
            emptySelectionMessage: 'Intet valgt',
            emptySearchMessage: 'Intet resultat',
            emptyMessage: 'Ingen valgmuligheder',
            aria: {
                trueLabel: 'Sandt',
                falseLabel: 'Falsk',
                nullLabel: 'Ikke valgt',
                star: '1 stjerne',
                stars: '{star} stjerner',
                selectAll: 'Alle valgt',
                unselectAll: 'Alle fravalgt',
                close: 'Luk',
                previous: 'Forrige',
                next: 'Næste',
                navigation: 'Navigation',
                scrollTop: 'Scroll top',
                moveTop: 'Flyt top',
                moveUp: 'Flyt op',
                moveDown: 'Flyt ned',
                moveBottom: 'Flyt bund',
                moveToTarget: 'Flyt til mål',
                moveToSource: 'Flyt til kilde',
                moveAllToTarget: 'Flyt alle til mål',
                moveAllToSource: 'Flyt alle til kilde',
                pageLabel: '{page}',
                firstPageLabel: 'Første side',
                lastPageLabel: 'Sidste side',
                nextPageLabel: 'Næste side',
                prevPageLabel: 'Forrige side',
                rowsPerPageLabel: 'Rækker pr. side',
                jumpToPageDropdownLabel: 'Spring til side dropdown',
                jumpToPageInputLabel: 'Spring til side input',
                selectRow: 'Række valgt',
                unselectRow: 'Række fravalgt',
                expandRow: 'Række udvidet',
                collapseRow: 'Række kollapset',
                showFilterMenu: 'Vis filtermenu',
                hideFilterMenu: 'Skjul filtermenu',
                filterOperator: 'Filter Operator',
                filterConstraint: 'Filter Begrænsning',
                editRow: 'Rediger række',
                saveEdit: 'Gem ændringer',
                cancelEdit: 'Forkast ændringer',
                listView: 'Listevisning',
                gridView: 'Netvisning',
                slide: 'Slide',
                slideNumber: '{slideNumber}',
                zoomImage: 'Forstør Billede',
                zoomIn: 'Zoom Ind',
                zoomOut: 'Zoom Ud',
                rotateRight: 'Roter Højre',
                rotateLeft: 'Roter Venstre'
            }
        }
    }
};
export default new PrimevueLocale();